import InternalApi from "../axios/internalApi";

export const getGlobalTermCondition = async () => {
  try {
    const response = await InternalApi.get({
      server: "api/v1/",
      path: "term-condition"
    });
    return response;
  } catch (error) {
    console.error("Error fetching global terms and conditions:", error);
    throw error;
  }
};

export const createGlobalTermCondition = async (termConditionData) => {
  try {
    const response = await InternalApi.post({
      server: "api/v1/",
      path: "term-condition/admin/global",
    }, termConditionData);
    return response.data;
  } catch (error) {
    console.error("Error creating global terms and conditions:", error);
    throw error;
  }
};

export const updateGlobalTermCondition = async (termConditionData) => {
  try {
    const response = await InternalApi.patch({
      server: "api/v1/",
      path: "term-condition/admin/global",
    }, termConditionData);
    return response.data;
  } catch (error) {
    console.error("Error updating global terms and conditions:", error);
    throw error;
  }
};
